<template>
            <div id="learingTikuWrong">
              <backHeader back-addr="/indexKaoyan"></backHeader>
                <br />

                <div v-show="tikuListShow">
                  <div @click="closeTikuList()" style="width:100%;text-align:center;">X</div>
                  <div class="flex-container" >
                  <div v-for="(item,index) in list">
                    <a @click="goChooseTiku(item,index)" v-if="item.answerSituation==2" class="right">{{index+1}}</a>
                    <a @click="goChooseTiku(item,index)" v-else-if="item.answerSituation==1" class="wrong">{{index+1}}</a>
                    <a @click="goChooseTiku(item,index)" v-else class="notAnswer">{{index+1}}</a>
                  </div>
                </div>
                </div>
                
                <div class="" v-if="hasWrong" style="padding-left:10px;padding-right:10px;border-bottom:1px solid #BBBBBB;" v-show="!tikuListShow">
                            <div  style="display:flex;text-align:center;">
                                <div style="flex:1;text-align:left;">
                                    <!-- <span class="" style="font-size:0.8rem;">{{showType(tiku.type)}}</span> -->
                                    <mt-badge size="small" color="#888">{{showType(tiku.type)}}</mt-badge>
                                </div>
                                <div style="flex:1;">
                                    <span style="font-size:0.8rem;" @click="goTikuList">{{answerCount+1}}/{{totalCount}}</span>
                                </div>
                                <div style="flex:1;text-align:right;">
                                    <!-- <img class="mui-media-object mui-pull-left" :src="collection" style="height:18px;width:18px;vertical-align:text-top;margin-right:4px;">
                                    <span style="font-size:0.8rem;">收藏</span> -->
                                    <collect-element v-bind:collect-data="tiku" v-bind:collect-state="tiku.collectionType" v-bind:collect-id="tiku.id" v-bind:collect-type="'tikuCollect'"></collect-element>
                                </div>
                            </div>
                            <br />
                            <div class="">
                                <div class="">
                                    <span style="font-size:16px;">{{tiku.content}}：</span>
                                </div>
                            </div>
                            <br />

                            <mt-checklist v-model="answerCheckBoxArr" :options="options">
                            </mt-checklist>
                            

                            <div class="" style="display:flex">
                                    <!-- <button style="flex:1" type="button" class="" @click="submitTiku()" v-show="tiku.answerAble == true">确定</button> -->
                                     <mt-button style="flex:1" plain type="danger" @click="submitTiku()" v-show="tiku.answerAble == true">确定</mt-button>
                            </div>

                            
                            <br />
                            <div class="" v-show="tiku.showAnswerStatus">
                                <div class="">
                                    <span v-if="tiku.answerSituation==1" style="color:red;">错误</span>
                                    <span v-if="tiku.answerSituation==2" style="color:green;">正确</span>
                                    <span style="font-size:0.8rem;">正确答案为:{{tiku.answer}}</span>
                                </div>
                            </div>
                            <br v-show="tiku.showAnswerStatus" />
                            <div class="" v-show="tiku.showAnswerStatus">
                                <div class="">
                                    <span style="font-size:0.8rem;">解析:{{tiku.tip}}</span>
                                </div>
                            </div>
                            <br v-show="tiku.showAnswerStatus" />
                            <div class="" style="display:flex">
                              <!-- <button style="flex:1" type="button" class="" v-if="this.answerCount!=0" @click="showPrevTiku()">上一题</button>
                              <button style="flex:1" type="button" class="" v-if="this.answerCount<this.totalCount-1" @click="showNextTiku()">下一题</button> -->
                              <mt-button style="flex:1" plain type="danger" v-if="this.answerCount!=0" @click="showPrevTiku()">上一题</mt-button>
                              <mt-button style="flex:1" plain type="danger" v-if="this.answerCount<this.totalCount-1" @click="showNextTiku()">下一题</mt-button>
                            </div>
                       
                            <!-- <div class="mui-row">
                                <div class="mui-col-sm-1 mui-col-xs-1">

                                </div>
                                <div class="mui-col-sm-11 mui-col-xs-11">
                                    <h4>1212</h4>
                                </div>
                            </div> -->
                            
                        </div>
                <div style="height:60px;"></div>
            </div>
</template>

<script>
import axios from "axios";
import Qs from "qs";
import Addr from "./../utils/getAPI";
import store from "@/store/index";
import CollectElement from "@/components/collect";
import { Toast, MessageBox } from "mint-ui";
import backHeader from "./../components/back-header.vue";


export default {
  components: {
    CollectElement,
    backHeader
  },
  data() {
    return {
      answerCheckBoxArr: [],
      //checklist设置
      options: [],
      tikuInfo:{
        rightNum:0,//答对题目数
        wrongNum:0,//答错题目数
        notAnswerNum:0,//未答题目数
        randomId:0,//随机答题答道哪个id的题目了
      },
      //是否显示题目列表
      tikuListShow: false,
      //本地缓存的答题情况
      localTikuAnswerSituation: null,
      //收藏是否为空
      hasWrong: true,
      showAnswerStatus: false,
      //答案字符串
      answerString: "",

      list: [
        {
          answerAble:true,
          answer: "A",
          four: "加载中",
          one: "加载中",
          tip: "无",
          id: 6,
          type: 1,
          two: "加载中",
          three: "加载中",
          content:
            "加载中"
        }
      ],
      totalCount: 3,
      answerCount: 0,
      tempTiku: "",
      //当前题目
      tiku: {
          answerAble:true,
          answer: "A",
          four: "加载中",
          one: "加载中",
          tip: "无",
          id: 6,
          type: 1,
          two: "加载中",
          three: "加载中",
          content:
            "加载中"
        },
      //上一道题目
      prevTiku: ""
    };
  },
  props: {},
  watch: {},
  methods: {
    goChooseTiku(item,index){
      //关闭题目列表
      this.tikuListShow=false;
      //题目等于item
      this.tiku=item;
      //为了answerCheckBoxArr不刷新，借一手
        this.$nextTick(()=>{
          this.answerCheckBoxArr=this.tiku.answerCheckBoxArr;
        });
      //获取该题目的序号
      this.answerCount=index;
      //关闭答案
      //this.showAnswerStatus = false;
      //清除选择按钮
      //this.clearCheckBox();
    },
    closeTikuList() {
      this.tikuListShow = false;
    },
    goTikuList() {
      console.log("go tiku list");
      this.tikuListShow = true;
    },
    
    submitTiku() {
      var count = this.answerCheckBoxArr.length;
      this.answerString = this.answerCheckBoxArr.join(",");

      if (this.tiku.type == 1 && count > 1) {
        MessageBox.alert("单选题只能选择一个答案！", "提示");
        return;
      }
      if (count == 0) {
        MessageBox.alert("至少选择一个答案！", "提示");
        return;
      }
      if (this.tiku.type == 2 && count < 2) {
        MessageBox.alert("多选题最少选择二个答案！", "提示");
        return;
      }

      this.$nextTick(()=>{
        
        //设置已经答题问题的信息
        this.list[this.answerCount].answerCheckBoxArr=this.answerCheckBoxArr;
        this.list[this.answerCount].answerAble=false;
        this.tiku.answerAble=false;
        this.tiku.showAnswerStatus=true;
        this.list[this.answerCount].showAnswerStatus=true;

        console.log("tick list is:");
        console.log(this.list[this.answerCount]);
        console.log("tiku tiku is:");
        console.log(this.tiku);
      });

      console.log("answerString is:");
      console.log(this.answerString);
      if (this.answerString == this.tiku.answer) {
        this.showAnswerStatus = true;
        MessageBox.alert("回答正确！", "提示");
        //将答对的信息设置一下*********
        this.list[this.answerCount].answerSituation = 2;

        return;
      } else {
        this.showAnswerStatus = true;
        MessageBox.alert("回答错误！", "提示");

        // //将错误题目写入redis数据库
        // var redisKey = this.$store.state.appData.userId + "-" + "tikuWrong";
        // var redisValue = this.tiku.id;
        // axios
        //   .post(
        //     getGoAPIPrefix() + "user/collect",
        //     Qs.stringify({
        //       key: redisKey,
        //       value: redisValue,
        //       operation: 1
        //     })
        //   )
        //   .then(res => {
        //     if (res.data.returnCode == 100) {
        //       console.log("collect success");
        //       console.log("userId is:");
        //       console.log(res.data.returnData);
        //     }
        //   })
        //   .catch(err => {
        //     mui.toast("收藏功能异常！");
        //     console.log("collect failed");
        //     console.log(err);
        //   });
        // return;
      }
      //   console.log("answer is:");
      //   console.log(this.answerCheckBox);
    },
    showPrevTiku() {
      //this.showAnswerStatus = false;
      //this.clearCheckBox();
      if (this.answerCount > 1) {
        this.answerCount--;
        // this.prevTiku = this.randomTikus[this.answerCount];
        // this.tiku = this.randomTikus[this.answerCount];
        this.prevTiku = this.list[this.answerCount];
        this.tiku = this.list[this.answerCount];
        this.options = [
        {
          label: this.tiku.one,
          value: "A"
        },
        {
          label: this.tiku.two,
          value: "B"
        },
        {
          label: this.tiku.three,
          value: "C"
        },
        {
          label: this.tiku.four,
          value: "D"
        }
      ];
        //为了answerCheckBoxArr不刷新，借一手
        this.$nextTick(()=>{
          this.answerCheckBoxArr=this.tiku.answerCheckBoxArr;
        });
      } else if (this.answerCount == 1) {
        this.answerCount--;
        //this.tiku = this.randomTikus[0];
        this.tiku = this.list[0];
        this.options = [
        {
          label: this.tiku.one,
          value: "A"
        },
        {
          label: this.tiku.two,
          value: "B"
        },
        {
          label: this.tiku.three,
          value: "C"
        },
        {
          label: this.tiku.four,
          value: "D"
        }
      ];
        //为了answerCheckBoxArr不刷新，借一手
        this.$nextTick(()=>{
          this.answerCheckBoxArr=this.tiku.answerCheckBoxArr;
        });
        this.prevTiku = "";
      } else {
        console.log("已经是最开始了");
      }
    },
    showNextTiku() {
      //this.showAnswerStatus = false;
      //this.clearCheckBox();
      this.randomGetTiku();
    },
    //初始化随机取出一个题目
    initRandomTiku() {
      this.tiku = this.list[0];
      this.options = [
        {
          label: this.tiku.one,
          value: "A"
        },
        {
          label: this.tiku.two,
          value: "B"
        },
        {
          label: this.tiku.three,
          value: "C"
        },
        {
          label: this.tiku.four,
          value: "D"
        }
      ];
      //根据上次打开的位置跳转
      //this.tiku=this.list[this.tikuInfo.randomId];
      //this.answerCount=this.tikuInfo.randomId;
      console.log("this tiku is:", this.tiku);
      this.prevTiku = "";
    },
    //取出一个题目
    randomGetTiku() {
      if (this.answerCount < this.list.length - 1) {
        this.prevTiku = this.tiku;
        this.answerCount++;
        //this.tiku = this.randomTikus[this.answerCount];
        this.tiku = this.list[this.answerCount];
        this.options = [
        {
          label: this.tiku.one,
          value: "A"
        },
        {
          label: this.tiku.two,
          value: "B"
        },
        {
          label: this.tiku.three,
          value: "C"
        },
        {
          label: this.tiku.four,
          value: "D"
        }
      ];
        //为了answerCheckBoxArr不刷新，借一手
        this.$nextTick(()=>{
          this.answerCheckBoxArr=this.tiku.answerCheckBoxArr;
        });
      } else {
        console.log("已经答完题目");
      }
    },
    showType: function(cellValue) {
      if (cellValue == "1") {
        return "单选";
      } else if (cellValue == "2") {
        return "多选";
      }
    },
    initTikuData() {
      // axios
      //   .get(getGoAPIPrefix() + "tiku/listTikuWrong?pageNum=1&pageRow=1000&id="+this.$store.state.appData.userId)
      //   .then(res => {
      //     console.log("res is:");
      //     console.log(res);
      //     if (res.data.returnCode == 100) {
      //       //初始化赋值题目列表，以及题目总数，还有随机抽取出第一道题目
      //       this.list = res.data.returnData.list;
      //       console.log("this list is:",this.list);
      //       // //默认设置收藏状态
      //       // this.list.forEach(function(value, index, array) {
      //       //   array[index].collectionType = false;
      //       // });

      //       //如果没有收藏，则不显示题目
      //       if(this.list ==null){
      //         this.hasWrong=false;
      //         mui.toast("没有错误的题目！");
      //       }
      //       this.totalCount = this.list.length;
      //       //0621
      //       this.initRandomTiku();
      //     }
      //   })
      //   .catch(err => {
      //     console.log(err);
      //   });

      this.list=[];

      let tikuAnswerSituation = JSON.parse(
        localStorage.getItem("tikuAnswerSituation")
      );
      //循环缓存中的题目，将答题状态为1的题目也就是错题给筛选出来
      for (var i = 0; i < tikuAnswerSituation.length; i++) {
        if (tikuAnswerSituation[i].answerSituation == 1) {
          this.list.push(tikuAnswerSituation[i]);
        }
      }

      if (this.list.length == 0) {
        this.hasWrong = false;
        MessageBox.alert("没有错误的题目！", "提示");
      }

      this.totalCount = this.list.length;

      console.log("list is:");
      console.log(this.list);
    }
  },
  filters: {},
  computed: {},
  created() {
    this.initTikuData();
    this.initRandomTiku();
  },
  mounted() {
    
  },
  beforeDestroy() {
    console.log("beforeDestroy");
    this.localTikuAnswerSituation = JSON.parse(
      localStorage.getItem("tikuAnswerSituation")
    );
    
    var localLen = this.localTikuAnswerSituation.length;
    var Len = this.list.length;
    //找到错题变成回答正确的题目
    for (var i = 0; i < Len; i++) {
      
      for (var j = 0; j < localLen; j++) {
        //如果id相等，且answerSituation不为空的情况下
        if (this.localTikuAnswerSituation[j].id == this.list[i].id &&this.list[i].answerSituation==2) {
          this.localTikuAnswerSituation[j].answerSituation=2;
          continue;
        }
      }
    }

    //初始化答题情况信息
    if(localStorage.getItem("tikuInfo")===null||localStorage.getItem("tikuInfo")===undefined){
        this.tikuInfo={
          rightNum:0,//答对题目数
          wrongNum:0,//答错题目数
          notAnswerNum:0,//未答题目数
          randomId:0//随机答题答道哪个id的题目了
        };
    }else{
        this.tikuInfo=JSON.parse(localStorage.getItem("tikuInfo"));
        this.tikuInfo.rightNum=0;
        this.tikuInfo.wrongNum=0;
        this.tikuInfo.notAnswerNum=0;
    }
    //统计答题情况
    for(var i=0;i<this.localTikuAnswerSituation.length;i++){
      if(this.localTikuAnswerSituation[i].answerSituation==2){
        this.tikuInfo.rightNum++;
      }
      if(this.localTikuAnswerSituation[i].answerSituation==1){
        this.tikuInfo.wrongNum++;
      }
      if(this.localTikuAnswerSituation[i].answerSituation==-1){
        this.tikuInfo.notAnswerNum++;
      }
    }//for
    localStorage.setItem("tikuInfo",JSON.stringify(this.tikuInfo));
    
    localStorage.setItem("tikuAnswerSituation", JSON.stringify(this.localTikuAnswerSituation));
  },
  destroyed() {}
};
</script>

<style scoped>
#about {
  width: 100%;
  height: 100%;
}

#about-img {
  width: 100%;
}

p {
  margin-left: 15px;
  margin-right: 15px;
}

.flex-container div {
  flex: 1;
  margin: 3px;
  width: 40px;
  height: 40px;
  display: inline-block;
  text-align: center;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 25px;
  background-clip: padding-box;
  min-width: 12%;
  max-width: 12%;
  vertical-align: center;
  line-height: 40px;
}

.wrong{
  color: red;
}

.right{
  color:green;
}

.notAnswer{
  color: gray;
}
</style>


// WEBPACK FOOTER //
// src/module-tiku/tikuWrong.vue